import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const Info = ({
  width = 2,
  height = 13,
  fill = colors.darkBlue,
  responsive = true,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2 13"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        d="M0 2.216h2V0H0v2.216ZM.076 13h1.886V3.688H.076V13Z"
        fill={fill}
      />
    </svg>
  )
}

export default Info
